import Cookie from 'js-cookie'

export default ({ app }) => {
  app.router.afterEach((to, from, next) => {
    let token = Cookie.get("token")
    let meta = []
    let metaAll = []
    if(to.path == "/login" || !token) {

    } else {
      if(!app.store.state.app.userInfo.userId) {
        app.store.dispatch("app/getUserInfo").then(res=> {
          let userMenu = res.menuTree
          let menuAll = res.allMenu
          userMenu.forEach(item => {
            item.children.forEach((child, idx) => {
              let router = '/' + item.menuRoute + child.menuRoute
              meta.push(router)
            })
          })
          let path = to.path;
          // console.log("------->：", path)
          if (path.lastIndexOf('/') == path.length - 1) {
            path = path.substring(0, path.length - 1)
            // console.log("------->：", path)
          }
          let idx = meta.findIndex(item => {
            // 精确匹配:完全相等,或者以path开头且后面跟着/或结尾
            return item === path || item.startsWith(path + '/') || item.startsWith(path + '?');
          });
          if (idx == -1) {
            // 没有权限 判断是否在全部菜单中
            menuAll.forEach((item, index) => {
              item.children.forEach((child, idx) => {
                let router = '/' + item.menuRoute + child.menuRoute
                metaAll.push(router)
              })
            })
            let index = metaAll.findIndex(item => {
              // 精确匹配:完全相等,或者以path开头且后面跟着/或?
              return item === path || item.startsWith(path + '/') || item.startsWith(path + '?');
            });
            if (index > -1) {
              // 路由存在于全部菜单中,但不在用户菜单中,说明无权限
              app.router.replace("/not-permission")
            }
          }
        })
      }
    }
  })
}
